export default "__VITE_ASSET__DL39Ct2F__"